import { Box } from '@chakra-ui/react';
import CardHeader from '@pages/ConsumerPromotion/components/Detail/EditSku/CardHeader';
import Table from './table';
import { useEditDetail } from '@pages/ConsumerPromotion/hooks/state/useEditDetail';
import { useMutateDetail } from '@pages/ConsumerPromotion/hooks/mutate/useMutateDetail';
import { omit } from 'lodash';
import { useFileUploadPopUp } from '@store/useFileUploadPopUp';
import { useSnackbarNotification } from '@store/snackbarNotification';
import { fileDownloader } from '@helpers/utils';
import { useEffect } from 'react';
import ModalDownloadDataClaim from './ModalDownloadDataClaim';
import usePaginationStore from '@pages/ConsumerPromotion/hooks/state/usePaginationCust';

export default function EditCustomer() {
    const stateEdit = useEditDetail();
    const { data } = usePaginationStore();
    const { set } = useFileUploadPopUp();
    const { updateDetailCustomer, uploadFileCustomerList, cancelUploadFileCustomerList } = useMutateDetail();
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    const disabledEdit = ['reject', 'active', 'waiting for approval', 'ready to claim', 'done', 'processing'].includes(
        stateEdit?.overviewData?.promotion_status?.status?.toLowerCase()
    );

    const handleDownloadTemplate = async () => {
        try {
            await fileDownloader({
                url: '/api/v1/promotion-claim/download/template-customer',
                fileName: 'Template upload daftar Customer.xlsx',
            });

            onChangeSnackbarNotification({
                status: 'success',
                description: 'Template berhasil didownload!',
                duration: 3,
            });
        } catch (err) {
            onChangeSnackbarNotification({
                status: 'error',
                description: 'Template gagal didownload!',
                duration: 3,
            });
        }
    };

    const controller = new AbortController();
    const handleUploadFile = async () => {
        const { files } = useFileUploadPopUp.getState();
        const { upload_token } = useEditDetail.getState();
        if (!files?.[0]) return;

        uploadFileCustomerList.mutate({
            promotion_id: stateEdit.id,
            file: files[0],
            upload_token,
            controller,
        });
    };

    const handleCancelUpload = () => {
        const { upload_token } = useEditDetail.getState();

        controller.abort();
        cancelUploadFileCustomerList.mutate({
            promotion_id: stateEdit.id,
            upload_token,
        });
    };

    const handleUpload = () => {
        set({
            isOpen: true,
            title: 'Upload Daftar Customer',
            onUploadFile: handleUploadFile,
            uploadProgressMessage: 'Sedang memeriksa data produk master ...',
            onDownloadTemplate: handleDownloadTemplate,
            isCanCancelUpload: true,
            onCancelUpload: handleCancelUpload,
        });
    };

    const handleEdit = () => {
        stateEdit.set({ isEditCustomer: true });
    };

    const handleSave = () => {
        const payload = data.map((p) => omit(p, 'id'));
        updateDetailCustomer.mutate({ id: stateEdit.id, payload: { customers: payload } });
    };

    return (
        <Box>
            <ModalDownloadDataClaim />

            <CardHeader
                title={`${stateEdit.isEditCustomer ? 'Masukkan ' : ''}Customer Eligible untuk Promo`}
                btnLabel="Upload Daftar Customer"
                handleUpload={handleUpload}
                handleEdit={handleEdit}
                handleSave={handleSave}
                isEdit={stateEdit.isEditCustomer}
                isCanEdit={stateEdit.isCanEdit && !disabledEdit}
                isDisabled={disabledEdit}
            />

            <Table />
        </Box>
    );
}
